import Logo from "../components/logo"
import Menu from "../components/menu"
import useAnimationStore from "../stores/use-animation"
import { Card } from "../components/card"
import { BackgroundTexts } from "../components/background-texts"
import BackButton from "../components/back-button"
import InstructionModal from "../components/instruction-modal"

import { useEffect } from "react"

export default function Home () {
  const { isStart} = useAnimationStore()
  useEffect(() => {

    console.log(`
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@GJP@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&Y777JB@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@P?7777775&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@BJ777777777?P@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&Y7777777777777JB@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@P?77777777777777775&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@BJ7777777777777777777?G@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@&YY5PGBB#&&@@@@@@@@@@@@&Y77777777777777777777777JB@@@@@@@@@@@@@@@@@&&##BGP#@@@@@@@@@@@@@
  @@@@@@@@@@@@&?7777777??JJY5PGGB#&&#YJJJJJJJ?77777777777?JJJJJJB@@&&&#BBGPP5YYJ???7777!P@@@@@@@@@@@@@
  @@@@@@@@@@@@&?7777777777777777777?P@@@@@@@@Y77777777777Y@@@@@@@@BJ?7777777777777777777B@@@@@@@@@@@@@
  @@@@@@@@@@@@@J77777777777777777JP#@@@@@@@@@Y77777777777Y@@@@@@@@@&GJ777777777777777777#@@@@@@@@@@@@@
  @@@@@@@@@@@@@J777777777777777?G@@@@@@@@@&BGJ77777777777?PGB#&@@@@@@@#Y777777777777777?&@@@@@@@@@@@@@
  @@@@@@@@@@@@@J7777777777777777?P&@@@&BP5PGBJ77777777777J&#BP55G#@@@&P?777777777777777?@@@@@@@@@@@@@@
  @@@@@@@@@@@@@Y777777777777777777?PB55G#@@@@Y77777777777Y@@@@@&BP5PP?77777777777777777J@@@@@@@@@@@@@@
  @@@@@@@@@@@@@Y7777777777777777777775@@@@@@@Y77777777777Y@@@@@@@&577777777777777777777Y@@@@@@@@@@@@@@
  @@@@@@@@@@@@@5777?5BBJ77777777777777JG@@@@@Y77777777777Y@@@@@&5?77777777777777Y5?7777P@@@@@@@@@@@@@@
  @@@@@@@@@@@@@P7YG&@@@@BJ77777777777777JB@@@Y77777777777Y@@@&5?77777777777777JB@@@BY7!G@@@@@@@@@@@@@@
  @@@@@@@@@@@@@&&@@@@@@@@@GJ77777777777777YB@Y77777777777J@#5777777777777777YB@@@@@@@#G&@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@G7777777777777775PJJYYYYYYYJJ5P7777777777777777P@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@GJG?7777777777JG&@@&#GPPPG#&@@#PJ77777777777Y#B7@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@7B@&P?77777JP#@@@&PYJJJJJJJYG@@@@B5?777777YB@@@?P@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@#7@@@@&5??5B@@@@@@5JJJJJJJJJJJ5@@@@@&GJ77Y#@@@@@PJ@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@B7@@@@@@#G#@@@@@@&JJJJJJJJJJJJJ&@@@@@@@#G&@@@@@@G?@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@#7@@@@@BJ77YG&@@@@5JJJJJJJJJJJP@@@@@@&GY??P&@@@@PJ@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@7B@@GJ777777?5#@@@GYJJJJJJJYG@@@@@B5?77777?G@@@?P@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@GJGJ77777777777JG&@@#BGGGB#@@@@#PJ7777777777JBB7@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@G77777777777777!?GYJJYYYYYJJJJPY!77777777777777P@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@BG&@@@@@@@GJ77777777777777?P&&?7777777777!P@GJ77777777777777YB@@@@@@@@@#@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@Y!?5#@@@GJ77777777777777?P&@@&?77777777777P@@@G?77777777777777Y#@@@@&PJ7B@@@@@@@@@@@@@
  @@@@@@@@@@@@@@J7777JPJ77777777777777?P&@@@@&?77777777777P@@@@&P?777777777777775#GY7777G@@@@@@@@@@@@@
  @@@@@@@@@@@@@@?777777777777777777775@@@@@@@&?77777777777P@@@@@@&5777777777777777777777G@@@@@@@@@@@@@
  @@@@@@@@@@@@@&?77777777777777777?GB55G#@@@@&?77777777777P@@@@&BP5P57777777777777777777P@@@@@@@@@@@@@
  @@@@@@@@@@@@@#7777777777777777JG@@@@&BP5PGBB?77777777777P#GP55G#@@@#5?7777777777777777P@@@@@@@@@@@@@
  @@@@@@@@@@@@@B7777777777777777P&@@@@@@@@&#GP777777777777YGB#@@@@@@@@@P77777777777777775@@@@@@@@@@@@@
  @@@@@@@@@@@@@G777777777777777777YB&@@@@@@@@&?77777777777G@@@@@@@@@#5?777777777777777775@@@@@@@@@@@@@
  @@@@@@@@@@@@@57777777777777777777?Y#@@@@@@@&?77777777777P@@@@@@@&Y?7777777777777777777Y@@@@@@@@@@@@@
  @@@@@@@@@@@@@Y!7777??JJYY5PGGB##&&&@@PJJJJJJ777777777777?JJJJJJJ5&&&#BGPP5YJ??77777777J@@@@@@@@@@@@@
  @@@@@@@@@@@@@BGBB##&&@@@@@@@@@@@@@@@@@G?!7777777777777777777777P&@@@@@@@@@@@@&&#BGGP5Y5@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&577777777777777777777Y#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@#J7777777777777777JB@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@G?777777777777?P@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&57777777777Y#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@#J777777?B@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@G?77?P&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&YY#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  I see you!
  Contact me: https://kflower.me/
  `)


  }, [])


  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-8 bg-background">

      <Logo />
     {isStart ?
     <BackButton />
     :
      <>

      <Menu />
      <BackgroundTexts />
      </>
    }

    <Card />
    <InstructionModal />
    </div>
  )
}
